import React from "react";
import { useQuery } from "@apollo/client";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretDown, faCaretRight } from "@fortawesome/free-solid-svg-icons";

import DtsReactTable from "../../reuseableComponents/dtsReactTable/DtsReactTable";
import { GET_DISINFECTION_BYPRODUCT_STAGE_2 } from "../../../queries/archiveQrys/MonitoringScheduleReportQueries";
import { sampleType, frequencyType } from "./../../../utilities/constants/WaterSystemConstants";
import { convertTimeStampToDate } from "./../../../utilities/commonFunctions/timeConversionFunctions";
import SkeletonLoader from "../../reuseableComponents/loaders/SkeletonLoader";
import ErrorHandler from "../../reuseableComponents/ErrorHandler";

const DisinfectionByProductStage2MonitoringTable = (props) => {
  const { systemId } = props;

  const columns = [
    {
      Header: "",
      id: "expander",
      width: 30,
      Cell: ({ row }) => (
        <span {...row.getToggleRowExpandedProps()}>
          {row.isExpanded ? (
            <FontAwesomeIcon className='font-icon' icon={faCaretDown} cypressid={row.original.systemId + "_dbp2d"} />
          ) : (
            <FontAwesomeIcon className='font-icon' icon={faCaretRight} cypressid={row.original.systemId + "_dbp2r"} />
          )}
        </span>
      )
    },
    {
      Header: "Sample Count",
      accessor: "sampleCount"
    },
    {
      Header: "Type",
      accessor: (d) => {
        return d.sampleType ? sampleType[d.sampleType] : "";
      }
    },
    {
      Header: "Frequency",
      accessor: (d) => {
        return d.frequency ? frequencyType[d.frequency] : "";
      }
    },
    {
      Header: "Sample Label",
      accessor: (d) => {
        return d.systemNumber + " DS001 Sample ID below";
      }
    }
  ];

  const details = React.useMemo(
    () => [
      {
        Header: "Sample ID",
        accessor: "sampleIdCode",
        width: 70
      },
      {
        Header: "Site",
        accessor: "site",
        width: 225
      },
      {
        Header: "Last Sampled",
        accessor: (d) => {
          return d.lastSampleDate ? convertTimeStampToDate(d.lastSampleDate) : "";
        }
      },
      {
        Header: "Next Sample Due",
        accessor: "nextSampleDateRange"
      }
    ],
    []
  );

  const { loading, error, data } = useQuery(GET_DISINFECTION_BYPRODUCT_STAGE_2, { variables: { systemId } });

  const subTable = React.useCallback(
    ({ row }) =>
      row.original.details.length > 0 ? (
        <DtsReactTable columns={details} data={row.original.details} headerColor='grey' />
      ) : (
        "No Data"
      ),
    [details]
  );

  const expandedRows = React.useMemo(() => {
    if (data) {
      let arr={};
      let d = data;
      if (d.getPublicDisinfectionByProductStage2.length > 0) {
        d.getPublicDisinfectionByProductStage2.forEach(function (elem, index) {
          if (elem.details) {
            if (elem.details.length > 0) {
              arr[index] = true;
            }
          }
        });
      }
      console.log("Array:" , arr);
      return arr;
    }
  }, [data]);

  if (loading) {
    return <SkeletonLoader width='100%' />;
  }

  if (error) {
    return <ErrorHandler error={error} />;
  }

  return (
    <>
      {data.getPublicDisinfectionByProductStage2.length > 0 ? (
        <>
          <DtsReactTable
            data={data.getPublicDisinfectionByProductStage2}
            columns={columns}
            headerColor='ddw'
            renderRowSubComponent={subTable}
            expandRows={true}
            expandedRowObj={expandedRows}
            subTableId={"_dbp2SubTable"}
            cypressid="dbp2MainTbl"

          />
          {data.getPublicDisinfectionByProductStage2[0].samplingDescription}
        </>
      ) : (
        <span>No Disinfection ByProduct Stage 2 Monitoring was found in the database.</span>
      )}
    </>
  );
};

export default DisinfectionByProductStage2MonitoringTable;
